import { RoutePath } from "#src/utils/route";
import { WorkflowRoutePath } from "..";

export const WorkflowDetailsRoutePath = WorkflowRoutePath.concat(
  new RoutePath<"workflowId", "task_id" | "context">({
    path: "/detail",
    title: "Workflow Detail",
  })
);
